import { ArrowCounterClockwiseIcon, TrashSimpleIcon, XIcon } from "@phosphor-icons/react";
import { Button } from "@heroui/react";

import { ICON_SIZE } from "@/config/constants";

interface NotesTrashSelectionToolbarProps {
  selectedNotesCount: number;
  onRestoreSelected: () => void;
  onDeleteSelected: () => void;
  onClearSelection: () => void;
}

export function NotesTrashSelectionToolbar({
  selectedNotesCount,
  onRestoreSelected,
  onDeleteSelected,
  onClearSelection,
}: NotesTrashSelectionToolbarProps) {
  if (selectedNotesCount === 0) return [];

  return [
    <Button key="restore-selected" variant="light" isIconOnly onPress={onRestoreSelected}>
      <ArrowCounterClockwiseIcon size={ICON_SIZE.md} />
    </Button>,
    <Button key="delete-selected" variant="light" isIconOnly onPress={onDeleteSelected}>
      <TrashSimpleIcon size={ICON_SIZE.md} />
    </Button>,
    <Button key="clear-selection" variant="light" isIconOnly onPress={onClearSelection}>
      <XIcon size={ICON_SIZE.md} />
    </Button>,
  ];
}
